import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TransitionsPopper from './TransitionsPopper';
import ClientProvider from './client';
export default createDemo(import.meta.url, TransitionsPopper, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/popper/demos/transitions/TransitionsPopper.tsx",
    "fileName": "TransitionsPopper.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Popper from '@mui/material/Popper';\nimport Fade from '@mui/material/Fade';\n\nexport default function TransitionsPopper() {\n  const [open, setOpen] = React.useState(false);\n  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);\n\n  const handleClick = (event: React.MouseEvent<HTMLElement>) => {\n    setAnchorEl(event.currentTarget);\n    setOpen((previousOpen) => !previousOpen);\n  };\n\n  const canBeOpen = open && Boolean(anchorEl);\n  const id = canBeOpen ? 'transition-popper' : undefined;\n\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <button aria-describedby={id} type=\"button\" onClick={handleClick}>\n        Toggle Popper\n      </button>\n      <Popper id={id} open={open} anchorEl={anchorEl} transition>\n        {({ TransitionProps }) => (\n          <Fade {...TransitionProps} timeout={350}>\n            <Box sx={{ border: 1, p: 1, bgcolor: 'background.paper' }}>\n              The content of the Popper.\n            </Box>\n          </Fade>\n        )}\n      </Popper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 34,
        "focusedLines": 12,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Popper from '@mui/material/Popper';\nimport Fade from '@mui/material/Fade';\n\nexport default function TransitionsPopper() {\n  const [open, setOpen] = React.useState(false);\n  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);\n\n  const handleClick = (event: React.MouseEvent<HTMLElement>) => {\n    setAnchorEl(event.currentTarget);\n    setOpen((previousOpen) => !previousOpen);\n  };\n\n  const canBeOpen = open && Boolean(anchorEl);\n  const id = canBeOpen ? 'transition-popper' : undefined;\n\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <button aria-describedby={id} type=\"button\" onClick={handleClick}>\n        Toggle Popper\n      </button>\n      <Popper id={id} open={open} anchorEl={anchorEl} transition>\n        {({ TransitionProps }) => (\n          <Fade {...TransitionProps} timeout={350}>\n            <Box sx={{ border: 1, p: 1, bgcolor: 'background.paper' }}>\n              The content of the Popper.\n            </Box>\n          </Fade>\n        )}\n      </Popper>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      <",
              [
                "span",
                "pl-ent",
                "button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-describedby"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "id"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "type"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "button",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClick"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleClick"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            "        Toggle Popper"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      </",
              [
                "span",
                "pl-ent",
                "button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Popper"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "id"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "id"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "open"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "open"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "anchorEl"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "anchorEl"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "transition"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              "({ ",
              [
                "span",
                "pl-v",
                "TransitionProps"
              ],
              " }) ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fade"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "TransitionProps"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "timeout"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "350"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "            <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "border"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "p"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "background.paper",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            "              The content of the Popper."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "            </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fade"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "        )",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Popper"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 34,
    "focusedLines": 12,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Popper",
      "@mui/material/Fade"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
